export default __webpack_public_path__ + "static/media/clients-04.209e84dd.svg";